import type { Router } from 'vue-router';
import type { Context, Middleware } from '../types/common';

export async function implementsMiddlewareOnRouter(router: Router): Promise<void> {
  const originalGetRoutes = router.getRoutes.bind(router);

  const getSortedRoutes = () => {
    return originalGetRoutes().sort((a, b) => {
      if (!a.meta.priority || (b.meta.priority && a.meta.priority > b.meta.priority)) {
        return 1;
      }

      if (!b.meta.priority || a.meta.priority < b.meta.priority) {
        return -1;
      }

      return 0;
    });
  };

  router.getRoutes = () => getSortedRoutes();

  router.beforeEach(async (to, from, next) => {
    const allMiddlewares: Middleware[] = [];

    to.matched.forEach((parent) => {
      if (Array.isArray(parent.meta?.middlewares) && parent.meta.middlewares.length) {
        allMiddlewares.push(...parent.meta.middlewares);
      }
    });

    if (Array.isArray(to.meta?.middlewares) && to.meta.middlewares.length) {
      allMiddlewares.push(...to.meta.middlewares);
    }

    const uniqueMiddlewares = allMiddlewares.filter(
      (middleware, index) => allMiddlewares.indexOf(middleware) === index
    );

    if (!allMiddlewares.length) {
      return next();
    }

    const context: Context = { from, to, next, router };

    for await (const middleware of uniqueMiddlewares) {
      const result = await middleware({ ...context });
      if (result) {
        return next(result);
      }
    }

    return next();
  });
}
